import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Application } from '@typeRoots/common/application';
// Define the ApplicationState type
interface ApplicationState {
  application: Partial<Application> | null;
  isDataSyncedToBackend: boolean; // Tracks unsaved changes
  applicationCreated: boolean;
}

// Initial state
const initialState: ApplicationState = {
  application: null, // Start with empty vehicle data
  isDataSyncedToBackend: true, // No unsaved changes
  applicationCreated: false,
};

// Create the slice
export const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    // Set application from backend data
    //when you get data from backend or create a new application call this
    setApplication(state, action: PayloadAction<Partial<Application> | null>) {
      state.application = action.payload;
      state.isDataSyncedToBackend = true; // No unsaved changes
    },

    // Update application by merging its new properties
    updateApplication(state, action: PayloadAction<Partial<Application> & { id: number }>) {
      const { id, ...updates } = action.payload;
      if (state.application) {
        state.application = { ...state.application, ...updates, id };
        state.isDataSyncedToBackend = true;
      }
    },

    // Mark application as saved
    updateIsSynced(state, action: PayloadAction<boolean>) {
      state.isDataSyncedToBackend = action.payload; // Data is now saved
    },
    // Mark application as saved
    updateApplicationCreated(state, action: PayloadAction<boolean>) {
      state.applicationCreated = action.payload; // Data is now saved
    },
    clearApplication(state) {
      state.application = null;
      state.applicationCreated = false;
    },
  },
});

// Export actions
export const {
  setApplication,
  updateApplication,
  updateIsSynced,
  updateApplicationCreated,
  clearApplication,
} = applicationSlice.actions;

// Export reducer
export default applicationSlice.reducer;
